import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { toast } from "./toast";
import { createPrintJob, updatePrintJob } from "../pages/Setting/deviceSettingsApi";

export const useTrackedPrint = ({ contentRef, documentType, getDocumentId, onAfterPrint }) => {
  const jobId = useRef(null);
  const browserPrint = useReactToPrint({
    contentRef,
    onAfterPrint: async () => {
      if (jobId.current) await updatePrintJob(jobId.current, "PRINTED").catch(() => {});
      jobId.current = null;
      onAfterPrint?.();
    },
    onPrintError: async (_, error) => {
      if (jobId.current) await updatePrintJob(jobId.current, "FAILED", error?.message || "Browser print failed.").catch(() => {});
      jobId.current = null;
      toast.error("Printing failed. The job is available in Devices & Printers for retry.");
    },
  });

  return async () => {
    try {
      const result = await createPrintJob(documentType, String(getDocumentId?.() || ""));
      jobId.current = result.job.printJobId;
      if (!result.useBrowserFallback) {
        toast.success(`${documentType} sent to ${result.printer?.name || "configured printer"}.`);
        return;
      }
      await updatePrintJob(jobId.current, "PRINTING");
    } catch (error) {
      toast.warning("Print tracking is unavailable. Opening the browser print dialog.");
      jobId.current = null;
    }
    browserPrint();
  };
};


